import { gql } from "@apollo/client";

export const GET_PACIENTES_SAP = gql`
query GetPacientesSAP(
    $codDelegacion: String!
    $where: EPacienteFullFilterInput
) {
    pacientesSAP(
        codDelegacion: $codDelegacion
        where: $where
    ) {
        idPaciente
        cod_Paciente
        nombre
        tipoDoc
        numeroDoc
        domicilio
        piso
        departamento
        cP
        localidad
        provincia
        cod_Provincia
        pais
        observacionExtra
    }
}
`;

export const adaptPaciente = (paciente) => {
  return {
    // idPaciente: paciente.idPaciente,
    codigoSAP: paciente.cod_Paciente,
    nombre: paciente.nombre,
    tipoDocumento: paciente.tipoDoc,
    numeroDocumento: paciente.numeroDoc,
    direccion: paciente.domicilio,
    provincia: paciente.provincia,
    piso: paciente.piso,
    departamento: paciente.departamento,
    codigoPostal: paciente.cP,
    localidad: paciente.localidad,
    cod_Provincia: paciente.cod_Provincia,
    pais: paciente.pais,
    observacionExtra: paciente.observacionExtra
  };
};

export const adaptPacientesSAPArray = (pacientes) => {
  return structuredClone(pacientes)?.
  map((paciente) => adaptPaciente(paciente));
};